export default __webpack_public_path__ + "static/media/MiniGamme.7337d4dc.png";